import { Component, OnInit, OnDestroy } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { AuthenticationService } from '../../services/authentication.service';
import { Subscription } from 'rxjs/Subscription';
import { TdDialogService } from '@covalent/core';
import { InventoryService } from '../../../agatextscreens/inventory/inventory.service';
import { CustomerService } from '../../../agatextscreens/accounting/customer/customer.service';
import { Piece } from '../../../agatextscreens/inventory/piece';

@Component({
  selector: 'app-new-prepared-piece',
  templateUrl: './new-prepared-piece.component.html',
  styleUrls: ['./new-prepared-piece.component.scss'],
  providers: [InventoryService, CustomerService]
})
export class NewPreparedPieceComponent implements OnInit, OnDestroy {
  _subscription: Subscription = new Subscription();
  piece_no: string;
  piece_id: number;
  unit_price: number;
  found: boolean = false;

  customer_id: number;
  order_items: Piece[] = [];
  available_credit: number;

  constructor(public _ref: MdDialogRef<NewPreparedPieceComponent>,
    private _inventoryService: InventoryService,
    private _customerService: CustomerService,
    public _authService: AuthenticationService,
    private _dialogService: TdDialogService) { }

  ngOnInit() {
    this._customerService.getOneCustomerCreditLimitInfo(this.customer_id).subscribe(
      cInfo => {
        this.available_credit = this.getRemainingCredit(cInfo);
      }
    )
  }

  getCurrentCreditLimit(details) {
    if (!details.credit_margin || !Array.isArray(details.credit_margin)) details.credit_margin = [];
    details.credit_margin = details.credit_margin.sort((a, b) => { return (new Date(a.date) > new Date(b.date)) ? -1 : 1 });

    let credit: number;
    if (details.credit_margin.length > 0) {
      credit = details.credit_margin[0].margin;
    } else {
      credit = 0;
    }

    return credit;
  }

  getRemainingCredit(details) {
    return Number.parseFloat(this.getCurrentCreditLimit(details) + '') - (Number.parseFloat(details.invoices_outstanding || '0') + Number.parseFloat(details.orders_outstanding || '0'))
  }

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

  confirm() {
    if (!this.piece_id || !this.unit_price) {
      this._dialogService.openAlert({ title: 'Invalid data', message: 'You are missing mandatory information' })
    } else {
      this._ref.close({ id: this.piece_id, unit_price: this.unit_price });
    }
  }

  orderContains(piece_number: string ): boolean {
    let contains: boolean = false;

    this.order_items.forEach(
      (i) => {
        if (i.piece_number == piece_number) {
          contains = true;
        }
      });

      return contains;
  }

  verifyPiece() {
    if (this.orderContains(this.piece_no)) {
      this._dialogService.openAlert(
        {title: 'WARNING', message: 'This piece already exists in this order, please select another piece'});
        this.piece_id = null;
        this.found = false; 
        return;
      }

    this._subscription.add(
      this._inventoryService.getPieceByPieceNumber(this.piece_no).subscribe(
        
        pc => {
          if (pc.id) {
            console.log('piece id result: ' + pc.id); 
            this._inventoryService.getPiece(pc.id, false).subscribe(
              fullPiece => {
                console.log('piece found: ' + fullPiece[0].id + ', ' + fullPiece[0].piece_number);
                if (fullPiece[0].id && !fullPiece[0].deleted) {
                  this.piece_id = pc.id;
                  this.found = true;
                } else {
                  this._dialogService.openAlert({ title: 'Invalid data', message: 'Unable to find matching piece' });
                  this.piece_id = null;
                  this.found = false;
                }
              });
          } else {
            this._dialogService.openAlert({ title: 'Invalid data', message: 'Unable to find matching piece' });
            this.piece_id = null;
            this.found = false;
          }
          
        },
        error => {
          this._dialogService.openAlert({ title: 'Invalid data', message: 'Error finding piece' });
          this.piece_id = null;
          this.found = false;
        }
      )
    );
  }


}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/dialogs/new-prepared-piece/new-prepared-piece.component.ts